import { activeDisplayName } from "@/auth/session";
import { type PlayerCustomization, loadCustomization, saveCustomization } from "./PlayerCustomization";
import { ColorPicker } from "./ColorPicker";
import { AvatarSelector } from "./AvatarSelector";
import { AudioControls } from "./AudioControls";
import { MicSettings } from "./MicSettings";
import { VoiceMeter } from "./VoiceMeter";

export class LeftSidebar {
  private current: PlayerCustomization;
  private onChange: ((c: PlayerCustomization) => void) | null = null;
  readonly voiceMeter: VoiceMeter;

  constructor() {
    this.current = loadCustomization();
    this.current.name = activeDisplayName || this.current.name;

    new ColorPicker().build(this.current, (tint) => {
      this.current.color = tint;
      saveCustomization(this.current);
      this.onChange?.(this.current);
    });

    new AvatarSelector().build(this.current, (type) => {
      this.current.avatarType = type;
      saveCustomization(this.current);
      this.onChange?.(this.current);
    });

    new AudioControls().init();

    const micRoot = document.getElementById("mic-settings");
    if (micRoot) {
      void new MicSettings(micRoot).init();
    }

    this.voiceMeter = new VoiceMeter();
    this.voiceMeter.init();
  }

  get customization(): PlayerCustomization {
    return this.current;
  }

  setChangeHandler(fn: (c: PlayerCustomization) => void): void {
    this.onChange = fn;
  }
}
